<template>
<div class="r-registry-tabs">
    <div class="r-registry-tabs__nav">
        <div class="r-registry-tabs__btn-wrapper">
            <button v-for="(tab, index) in $slots.default()" :key="index"
                :class="['r-registry-tabs__button', { 'r-registry-tabs__button--active': activeTab === index }]"
                @click="switchTab(index)">
                {{ tab.props.title }}
            </button>
        </div>
    </div>
    <div class="r-registry-tabs__content">
        <template v-for="(tab, index) in $slots.default()" :key="index">
            <div v-show="activeTab === index" class="r-registry-tabs__pane">
                <component :is="tab" />
            </div>
        </template>
    </div>
</div>
</template>

<script>
export default {
    name: 'TabsComponent',
    components: {},
    props: {},
    data() {
        return {
            activeTab: 0
        }
    },
    mounted() { },
    methods: {
        switchTab(index) {
            this.activeTab = index
        }
    }
}
</script>
